import React from "react";
import Main from "../../parts/mainPage/index";
import {
  LinesList,
  Lines,
  Services,
  Transactions,
  UserAuth,
  UserInfo,
  Promotions,
  Promotion,
  Setting,
  ChangeEmailList,
  InvoicelList,
  InvoiceOfUser,
  Output,
  CouncilCalendar
} from "../../parts/index";
import Activities from "../../parts/activities";
import ActivePackage from "../../parts/activePackages";

function SwitchBody(props) {
  switch (props.type) {
    case 1:
      return (
        <Main
          login={props.login}
          token={props.token}
          search={props.search}
          setLogin={props.setLogin}
          setToken={props.setToken}
          setSearch={props.setSearch}
          setExpire={props.setExpire}
          setUserId={props.setUserId}
          searchTerm={props.searchTerm}
          searchData={props.searchData}
          searchPages={props.searchPages}
          setLastLogin={props.setLastLogin}
          searchFilter={props.searchFilter}
          setSearchTerm={props.setSearchTerm}
          setSearchData={props.setSearchData}
          setSearchPages={props.setSearchPages}
          setSearchFilter={props.setSearchFilter}
          selectedPageIndex={props.selectedPageIndex}
          setSelectedPageIndex={props.setSelectedPageIndex}
          setData={props.data}
        />
      );
    case 2:
      return (
        <UserInfo
          login={props.login}
          token={props.token}
          userId={props.userId}
        />
      );
    case 3:
      return (
        <UserAuth
          login={props.login}
          token={props.token}
          userId={props.userId}
        />
      );
    case 4:
      return (
        <Services
          login={props.login}
          token={props.token}
          userId={props.userId}
        />
      );
    case 5:
      return (
        <Lines login={props.login} token={props.token} userId={props.userId} />
      );
    case 6:
      return (
        <LinesList
          login={props.login}
          token={props.token}
          setUserId={props.setUserId}
          setSearch={props.setSearch}
        />
      );
    case 7:
      return (
        <Transactions
          login={props.login}
          token={props.token}
          userId={props.userId}
        />
      );
    case 8:
      return (
        <Promotions
          login={props.login}
          token={props.token}
          userId={props.userId}
        />
      );
    case 9:
      return (
        <Promotion
          login={props.login}
          token={props.token}
          userId={props.userId}

        />
      );
    case 10:
      return (
        <Setting
          login={props.login}
          token={props.token}
          userId={props.userId}

        />
      );
    case 11:
      return (
        <ChangeEmailList
          login={props.login}
          token={props.token}
          userId={props.userId}
          setUserId={props.setUserId}

        />
      );
    case 17:
      return (
        <CouncilCalendar
          login={props.login}
          token={props.token}
          userId={props.userId}
          setUserId={props.setUserId}

        />
      );

    case 12:
      return (
        <InvoicelList
          login={props.login}
          token={props.token}
          userId={props.userId}
        />
      );

    case 13:
      return (
        <InvoiceOfUser
          login={props.login}
          token={props.token}
          userId={props.userId}
        />
      );

    case 14:
      return (
        <Output
          login={props.login}
          token={props.token}
          userId={props.userId}
        />
      );

    case 15:
      return (
        <Activities
          login={props.login}
          token={props.token}
          userId={props.userId}
        />
      );

      case 18:
        return (
          <ActivePackage
            login={props.login}
            token={props.token}
            userId={props.userId}
          />
        );

    // default:
    //   return <Main />;
  }
}
export default SwitchBody;
